import script from "./DataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=17bb1f6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bb1f6c"]])

export default __exports__